import { render, staticRenderFns } from "./Regenerate.vue?vue&type=template&id=18d18b94&"
import script from "./Regenerate.vue?vue&type=script&lang=js&"
export * from "./Regenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports